export enum ABTest {
  A = 'A',
  B = 'B',
}
